// Same palette as kriha-one-frontend/src/theme (terracotta), applied to MUI.
import { createTheme } from "@mui/material/styles";

export default createTheme({
  palette: {
    primary: { main: "#cb6c49", dark: "#914829" },
    secondary: { main: "#914829" },
    background: { default: "#f8f6f4", paper: "#ffffff" },
    text: { primary: "#1a0f0a" },
    success: { main: "#1f9c6c" },
    error: { main: "#c0392b" },
  },
  typography: { fontFamily: '"Montserrat", sans-serif' },
});
